import type { UnifiedSubscription, BillingInvoice, BillingProduct } from "~/types/billing";

export function useBilling() {
  const auth = useAuthStore();

  async function getSubscription(): Promise<UnifiedSubscription> {
    const response = (await auth.api("get", "/store/lemon/subscription")) as any;
    return response.data as UnifiedSubscription;
  }

  async function getProducts(): Promise<{
    product: BillingProduct;
    storeUrl: string;
    variants: BillingProduct[];
  }> {
    const response = (await auth.api("get", "/store/lemon/products")) as any;
    return response.data as {
      product: BillingProduct;
      storeUrl: string;
      variants: BillingProduct[];
    };
  }

  async function getPortalUrl(): Promise<string> {
    const response = (await auth.api("get", "/store/lemon/portal")) as any;
    return response.data.portalUrl as string;
  }

  async function getInvoices(): Promise<BillingInvoice[]> {
    const response = (await auth.api("get", "/store/lemon/invoices")) as any;
    return response.data as BillingInvoice[];
  }

  return {
    getSubscription,
    getProducts,
    getPortalUrl,
    getInvoices,
  };
}
